var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.833374 3C0.833374 2.17157 1.50495 1.5 2.33337 1.5H17.3334C18.1618 1.5 18.8334 2.17157 18.8334 3V18C18.8334 18.8284 18.1618 19.5 17.3334 19.5H2.33337C1.50495 19.5 0.833374 18.8284 0.833374 18V3ZM17.3334 3H2.33337V18H17.3334V3Z",
    fill: "#2E334D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3334 0C14.7476 0 15.0834 0.335786 15.0834 0.75V3.75C15.0834 4.16421 14.7476 4.5 14.3334 4.5C13.9192 4.5 13.5834 4.16421 13.5834 3.75V0.75C13.5834 0.335786 13.9192 0 14.3334 0Z",
    fill: "#2E334D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33337 0C5.74759 0 6.08337 0.335786 6.08337 0.75V3.75C6.08337 4.16421 5.74759 4.5 5.33337 4.5C4.91916 4.5 4.58337 4.16421 4.58337 3.75V0.75C4.58337 0.335786 4.91916 0 5.33337 0Z",
    fill: "#2E334D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.833374 6.75C0.833374 6.33579 1.16916 6 1.58337 6H18.0834C18.4976 6 18.8334 6.33579 18.8334 6.75C18.8334 7.16421 18.4976 7.5 18.0834 7.5H1.58337C1.16916 7.5 0.833374 7.16421 0.833374 6.75Z",
    fill: "#2E334D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.70837 10.4996C5.70837 10.0854 6.04416 9.74963 6.45837 9.74963H9.08337C9.37168 9.74963 9.63446 9.91489 9.75935 10.1747C9.88424 10.4346 9.84913 10.743 9.66903 10.9682L8.83802 12.0069C9.08104 12.1702 9.2905 12.3797 9.45399 12.6243C9.65957 12.9319 9.78614 13.2854 9.82249 13.6536C9.85884 14.0217 9.80384 14.3932 9.66237 14.735C9.52089 15.0769 9.29731 15.3786 9.01142 15.6134C8.72553 15.8482 8.38615 16.0089 8.02334 16.0812C7.66052 16.1535 7.28547 16.1353 6.93138 16.0281C6.5773 15.9209 6.25511 15.728 5.99335 15.4666C5.70028 15.1739 5.69999 14.699 5.99271 14.4059C6.28542 14.1129 6.7603 14.1126 7.05337 14.4053C7.14062 14.4924 7.24802 14.5567 7.36604 14.5925C7.48407 14.6282 7.60909 14.6343 7.73003 14.6102C7.85097 14.586 7.96409 14.5325 8.05939 14.4542C8.15469 14.3759 8.22921 14.2754 8.27637 14.1614C8.32353 14.0475 8.34186 13.9237 8.32975 13.801C8.31763 13.6782 8.27544 13.5604 8.20691 13.4579C8.13838 13.3553 8.04563 13.2713 7.93687 13.2132C7.82811 13.155 7.70669 13.1246 7.58337 13.1246C7.29507 13.1246 7.03229 12.9594 6.9074 12.6995C6.78251 12.4397 6.81762 12.1312 6.99772 11.9061L7.52291 11.2496H6.45837C6.04416 11.2496 5.70837 10.9138 5.70837 10.4996Z",
    fill: "#2E334D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1688 9.82881C13.4229 9.95586 13.5834 10.2156 13.5834 10.4996V15.3746C13.5834 15.7888 13.2476 16.1246 12.8334 16.1246C12.4192 16.1246 12.0834 15.7888 12.0834 15.3746V11.9996L11.7834 12.2246C11.452 12.4732 10.9819 12.406 10.7334 12.0746C10.4848 11.7433 10.552 11.2732 10.8834 11.0246L12.3834 9.89963C12.6106 9.72919 12.9147 9.70177 13.1688 9.82881Z",
    fill: "#2E334D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendarIcon.6ff932fa7b6bc58cef3263e21bc4b03d.svg";
export { ForwardRef as ReactComponent };